// load polyfill
import { share } from '@spinnwerk/polyfills';
share();

/**
 * Initializes WebShare API
 *
 * @param {NodeList} triggers
 * @param {Object} [settings={}]
 * @param {string} settings.title - Optional setting that can be overridden by setting data-attribute <code>data-title</code> on the trigger or document <code>title</code>.
 * @param {string} settings.description - Optional setting that can be overridden by setting data-attribute <code>data-description</code> on the trigger or document <code>description</code> metadata.
 * @param {string} settings.url - Optional setting that can be overridden by setting data-attribute <code>data-url</code> on the trigger or document <code>url</code>.
 * @param {string} settings.fbId - Optional setting that can be overridden by setting data-attribute <code>data-fbId</code> on the trigger.
 * @param {string} settings.hashtags - Comma-separated hashtag strings (hashtags must be written without # symbol).
 * @param {Object} [apps={}]
 * @param {boolean} [apps.copy=true] - Whether this app is visible.
 * @param {boolean} [apps.email=true] - Whether this app is visible.
 * @param {boolean} [apps.print=false] - Whether this app is visible.
 * @param {boolean} [apps.sms=false] - Whether this app is visible.
 * @param {boolean} [apps.messenger=true] - Whether this app is visible.
 * @param {boolean} [apps.facebook=true] - Whether this app is visible.
 * @param {boolean} [apps.whatsapp=true] - Whether this app is visible.
 * @param {boolean} [apps.twitter=false] - Whether this app is visible.
 * @param {boolean} [apps.linkedin=false] - Whether this app is visible.
 * @param {boolean} [apps.telegram=false] - Whether this app is visible.
 * @param {boolean} [apps.skype=false] - Whether this app is visible.
 * @param {string} [apps.language='de'] - Specify language to be used.
 */
export function initWebShare(
    triggers,
    { title = '', description = '', url = '', fbId = '', hashtags = '' } = {},
    {
        copy = true,
        email = true,
        print = false,
        sms = false,
        messenger = true,
        facebook = true,
        whatsapp = true,
        twitter = false,
        linkedin = false,
        telegram = false,
        skype = false,
        language = 'de',
    } = {},
) {
    let canonical = document.querySelector('link[rel=canonical]')
            ? document.querySelector('link[rel=canonical]').href
            : null,
        documentUrl = canonical ? canonical : document.location.href,
        documentTitle = document.title,
        documentDescription = document.querySelector('[name~=description]'),
        documentFbId = document.querySelector('[property~="fb:app_id"]');

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const {
                title: elementTitle,
                description: elementDescription,
                url: elementUrl,
                fbId: elementFbId,
                hashtags: elementHashtags,
            } = trigger.dataset;

            navigator
                .share(
                    {
                        title: elementTitle || title || documentTitle,
                        text: elementDescription || description || (documentDescription && documentDescription.content),
                        url: elementUrl || url || documentUrl,
                        fbId: elementFbId || fbId || (documentFbId && documentFbId.content),
                        hashtags: elementHashtags || hashtags,
                    },
                    {
                        copy,
                        email,
                        print,
                        sms,
                        messenger,
                        facebook,
                        whatsapp,
                        twitter,
                        linkedin,
                        telegram,
                        skype,
                        language,
                    },
                )
                .catch(() => {});
        });
    });
}
